import React, { Component } from 'react';

import PropTypes from 'prop-types';

import CoreEditor from './CoreEditor';
import ShortcutBoundary from './ShortcutBoundary';

/**
 * Rich Text Editor for React
 *
 * @param {string} placeholder Specifies a short hint that describes the expected value of the input
 * @param {boolean} listEnabled Specifies that editor should support lists (unordered, orderd)
 * @param {string} value Specifies a short hint that describes the expected value of the input
 * @param {boolean} isFocused Specifies that editor should automatically get focus
 * @param {Function} onChange Gets called when the value of an element has been changed.
 * @param {Function} onSave Gets called when the user presses 'Enter'
 * @param {Function} onBlur Gets called when the editor loses focus
 * @param {Function} onClick Gets called when the user clicks on the editor
 *
 */

class Editor extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    listEnabled: PropTypes.bool,
    value: PropTypes.string,
    isFocused: PropTypes.bool,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
    shouldLoadToolbar: PropTypes.bool,
  };

  render() {
    return (
      <ShortcutBoundary>
        <CoreEditor {...this.props} />
      </ShortcutBoundary>
    );
  }
}

export default Editor;
